import * as React from 'react';
import { SortByListItem } from 'ui/sort-order/sort-by-list/sort-by-item/sort-by-item';
import { DefaultSortOrder, SortOptions } from 'ui/sort-order/types';
import styles from './sort-by-list.scss';
export interface SortByListProps {
  options: SortOptions;
  translation: any;
  onAdd: (e: React.SyntheticEvent<any>) => void;
  onMove: (type: number, value: number) => void;
  onDefaultOrderChange: (sortByItem: DefaultSortOrder) => void;
  onDefaultOrderRemove: (index: number) => void;
  onSelectedOptions: (sortByItem: DefaultSortOrder) => any;
}

export const SortByList = (props: SortByListProps) => {
  const items = [...props.options.defaultSortOrder]
    .sort((a, b) => a.orderBySequence - b.orderBySequence)
    .map((sortByItem, index) => <div key={index}>
      <SortByListItem
        onDefaultOrderChange={props.onDefaultOrderChange}
        onDefaultOrderRemove={props.onDefaultOrderRemove}
        onSelectedOptions={props.onSelectedOptions}
        onMove={props.onMove}
        translation={props.translation}
        index={index}
        sortByItem={sortByItem}
        options={props.options} />
    </div>);

  return (<div>
    <div className={styles.sortByListItems}>
      {items}
    </div>
    <a href="#" className="ui-standalone-link" onClick={props.onAdd}>
      {props.options.defaultSortOrder.filter((e) => e.domainNode.value === -1).length === 0
        && props.options.sortOptions.length !== props.options.defaultSortOrder.length
        ? '+ ' + props.translation.sort_order_button_add_sort_param : ''}
    </a>
  </div>);
};
